
import { SET_USER, LOGOUT_USER } from '../actions/userActions';

const initialState = {
  isAuthenticated: false,
  userInfo: null,
};

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_USER:
      return {
        ...state,
        isAuthenticated: true,
        userInfo: action.payload,
      };
    case LOGOUT_USER:
      case 'USER_LOGOUT':
      return initialState; // Reset state to initial
    default:
      return state;
  }
};

export default userReducer;
